import React from "react";

const ModalDialog = props => {
	const content = props.children ? props.children : <p>{props.message}</p>;

	const closeButton = props.close ? (
		<button type="button" className="close" aria-label="Close" onClick={props.close}>
			&times;
		</button>
	) : (
		""
	);

	const primaryButton = props.primaryCallback ? (
		<button
			type="button"
			className="btn btn-primary"
			aria-label={props.primaryButtonName || "Okay"}
			onClick={props.primaryCallback}
		>
			{props.primaryButtonName || "Okay"}
		</button>
	) : (
		""
	);

	const secondaryButton = props.secondaryCallback ? (
		<button
			type="button"
			className="btn btn-secondary"
			aria-label={props.secondaryButtonName || "Cancel"}
			onClick={props.secondaryCallback}
		>
			{props.secondaryButtonName || "Cancel"}
		</button>
	) : (
		""
	);

	return (
		<div className="modal" tabIndex="-1" role="dialog">
			<div className="modal-dialog" role="document">
				<div className="modal-dialog__header">
					<h5 className="modal-dialog__header__title">{props.title}</h5>
					{closeButton}
				</div>
				<div className="modal-dialog__body">{content}</div>
				<div className="modal-dialog__footer">
					{primaryButton}
					{secondaryButton}
				</div>
			</div>
		</div>
	);
};

export default ModalDialog;

/*
********************
Alex's notes
********************

OnBase E-Forms define several types of Modal: [Progress, Message, Confirm, Select, Input]

MyAccount definitely does not require all these options at this time

1) Progress Modal

Displays beach-ball, not progress bar

	function(message)

2) Message Modal

Message and "Okay" button
Style options: [success, info, warning, danger]

	function(message, style)

3) Confirm Modal

	function (message, style, yesLabel, noLabel, yesCallback, noCallback)

4) Select Modal

	function (message, selectValueArray, style, yesLabel, noLabel, yesCallbackm, noCallback)

5) Input Modal

	function(message, defaultValue, mask, placeholder, maxlength, style, yesLabel, noLabel, yesCallback, noCallback)

*/
